import './index.scss';
import { Dropdown, Menu } from '@umu/umu-design';
import type { IDropdownProps } from '@umu/umu-design/es/components/Dropdown/interface';
import { IMenuItemInfo } from '@umu/umu-design/es/components/Menu/interface';
import React, { useEffect, useState } from 'react';

interface IPropsShared {
    children: JSX.Element | React.ReactNode;
    className?: string;
    trigger?: 'click' | 'hover';
    /** 与 umu-design Dropdown 一致；不传则走组件默认定位 */
    placement?: IDropdownProps['placement'];
    /** 透传 Dropdown，便于外层样式（如最大高度滚动） */
    overlayClassName?: string;
    onChange?: (value: string) => void;
    /** 下拉展开/收起，与 umu-design Dropdown onVisibleChange 一致 */
    onVisibleChange?: (visible: boolean) => void;
    onLayoutCallback?: (data: { onVisibleChange: (visible: boolean) => void }) => void;
}

/** 自定义浮层与内置 Menu 二选一：有 overlayNode 时不使用 list；无 overlayNode 时必须传 list */
export type IProps =
    | (IPropsShared & { overlayNode: React.ReactNode; list?: IMenuItemInfo[] })
    | (IPropsShared & { list: IMenuItemInfo[]; overlayNode?: undefined });

export const MenuDrop = (props: IProps) => {
    const {
        list = [],
        className = '',
        trigger = 'hover',
        placement,
        overlayNode,
        overlayClassName,
        onChange,
        onVisibleChange: onVisibleChangeProp,
    } = props;
    const [visible, setVisible] = useState<boolean>(false);
    const onVisibleChange = (next: boolean) => {
        setVisible(next);
        onVisibleChangeProp?.(next);
    };
    const onMenuChange = (value: { key: string }) => {
        onChange?.(value.key);
        setVisible(false);
    };
    useEffect(() => {
        props?.onLayoutCallback?.({ onVisibleChange });
        return () => {
            setVisible(false);
        };
    }, []);
    return (
        <Dropdown
            overlay={overlayNode ? <div className={`${className} overlay-node`}>{overlayNode}</div> : <Menu list={list} className={className} itemClassName={`custom-menu-drop-item ${className}-item`} onClick={onMenuChange} />}
            visible={visible}
            trigger={[trigger]}
            placement={placement}
            overlayClassName={overlayClassName}
            onVisibleChange={onVisibleChange}
        >
            <div className={`${className}-child ${className}-child-${visible ? 'active' : ''}`}>{props.children}</div>
        </Dropdown>
    );
};
